function isParticipantOnboardingEnable(event, stepName) {
  return event?.participants?.onboarding?.find((step) => step.name === stepName)?.enable
}


export { isParticipantOnboardingEnable }